/** Finishing follows the selected room scope, never the price tier. */
export function packageFinishSummary(scope: string[]): string {
  const raw = scope.some(line => /Unfinished \/ raw wood/.test(line))
  const finished = scope.some(line => /Frame:|Gloss White|Matte White|Custom Color/.test(line))
  if (raw && finished) return 'Room-specific finishes as selected; raw wood only in rooms marked unfinished'
  if (raw) return 'Unfinished / raw wood, as selected for this design'
  if (finished) return 'Selected paint and finish included as listed in your room scope'
  return 'Finish as specified in your room scope; confirm any unlisted finish before approval'
}
